import { render } from "./SubAdminAddEditForm.vue?vue&type=template&id=036bffec&scoped=true"
import script from "./SubAdminAddEditForm.vue?vue&type=script&lang=js"
export * from "./SubAdminAddEditForm.vue?vue&type=script&lang=js"

import "./SubAdminAddEditForm.vue?vue&type=style&index=0&id=036bffec&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/PRD_sharetreats_v1_hr_company_dashboard_client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-036bffec"]])

export default __exports__